import moment from 'moment'
import 'moment/locale/es'
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale('es')

const reporteDeFlujoDeEfectivoPdf = (values) => {
    const empresa = values.empresa


    let filtrados = []

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }


    const diasFlujoDeEfectivo = values.diasFlujoDeEfectivo

    const totales = diasFlujoDeEfectivo.reduce((acc, valueDFE) => {
        acc.movimientosDia += valueDFE.movimientosDia || 0
        acc.ingresos += valueDFE.ingresos || 0
        acc.egresos += valueDFE.egresos || 0
        acc.cuentasPorPagar += valueDFE.cuentasPorPagar || 0
        acc.cuentasPorCobrar += valueDFE.cuentasPorCobrar || 0
        return acc
    }, {
        movimientosDia: 0,
        ingresos: 0,
        egresos: 0,
        cuentasPorPagar: 0,
        cuentasPorCobrar: 0
    })

    const diasFlujoDeEfectivoTable = diasFlujoDeEfectivo.map(valueDFE => {
        return [
            {style: 'textoTabla', text: valueDFE.dia, alignment: 'center'}, 
            {text: dineroDisabledMask(valueDFE.saldoInicial), style: 'textoTabla', alignment: 'right'}, 
            {text: dineroDisabledMask(valueDFE.movimientosDia), style: 'textoTabla', alignment: 'right'}, 
            {text: dineroDisabledMask(valueDFE.ingresos), style: 'textoTabla', alignment: 'right'}, 
            {text: dineroDisabledMask(valueDFE.egresos), style: 'textoTabla', alignment: 'right'}, 
            {text: dineroDisabledMask(valueDFE.cuentasPorPagar), style: 'textoTabla', alignment: 'right'}, 
            {text: dineroDisabledMask(valueDFE.cuentasPorCobrar), style: 'textoTabla', alignment: 'right'},
            {text: dineroDisabledMask(valueDFE.saldoFinal), style: 'textoTabla', alignment: 'right'}, 
        ]
    })

    // Agregar fila de totales
    const filaTotales = [
        {text: 'TOTALES', style: 'tituloTabla', alignment: 'center'}, 
        {text: '', style: 'tituloTabla', alignment: 'right'}, 
        {text: dineroDisabledMask(totales.movimientosDia), style: 'tituloTabla', alignment: 'right'}, 
        {text: dineroDisabledMask(totales.ingresos), style: 'tituloTabla', alignment: 'right'}, 
        {text: dineroDisabledMask(totales.egresos), style: 'tituloTabla', alignment: 'right'}, 
        {text: dineroDisabledMask(totales.cuentasPorPagar), style: 'tituloTabla', alignment: 'right'}, 
        {text: dineroDisabledMask(totales.cuentasPorCobrar), style: 'tituloTabla', alignment: 'right'},
        {text: '', style: 'tituloTabla', alignment: 'right'}, 
    ]

    var dd = {
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: [ '18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80] 
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                  headerRows: 1,
                                  widths: ["100%"],
                
                                  body: [
                                    [
                                        { 
                                        text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                        style: "tableHeader" 
                                        }
                                    ],
                                    [
                                      {
                                        text: "R.F.C: "+empresa.rfc,
                                        style: "textoChico",
                                        alignment: "center",
                                      },
                                    ],
                                    [
                                        {
                                          text: empresa.calle+' '+
                                          empresa.numeroCalle+' '+
                                          (empresa.numeroInterior ? empresa.numeroInterior : '')
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                    [
                                        {
                                          text: empresa.colonia.tipoAsentamiento+' '+
                                          empresa.colonia.nombre+' C.P. '+
                                          empresa.colonia.cp+' '+
                                          empresa.municipio.nombre+' '+
                                          empresa.estado.abreviatura+' '+
                                          empresa.pais.abreviatura+' '
                                          ,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                      [{text: 'FLUJO DE EFECTIVO PRESUPUESTADO', style: 'tableHeader'}],
                                  ],
                                },
                                layout: "noBorders",
                              },
                            {
                                border: [false, false, false, false],
                                    table: {
                                    headerRows: 1,
                                    widths: ['100%'],
                                
                                    body: [
                                        [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                        [{text: moment(values.fechaFinal).locale('es').format('ll'), style: 'textoChico', alignment: 'center'}],
                                        [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                        [{text: moment().locale('es').format('ll'), style: 'textoChico', alignment: 'center'}],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]
    
                    ]
                },
            },
            {text: 'Datos de filtrado:'},
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                                        defaultBorder: false,
                                    },
                    
                    body: filtrados,
                },
                            layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
                
            },
            {
                style: 'tableExample',
                table: {
                    widths: ['10%', '15%', '12%', '12%', '12%', '12%', '12%', '15%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                          {text: 'Fecha', style: 'tituloTabla'},
                          {text: 'Saldo Inicial', style: 'tituloTabla'},
                          {text: 'Movimientos del dia', style: 'tituloTabla'},
                          {text: 'Ingresos', style: 'tituloTabla'},
                          {text: 'Egresos', style: 'tituloTabla'},
                          {text: 'Cuentas por Pagar', style: 'tituloTabla'},
                          {text: 'Cuentas por Cobrar', style: 'tituloTabla'},
                          {text: 'Saldo Final', style: 'tituloTabla'},
                        ],
                        ...diasFlujoDeEfectivoTable,
                        filaTotales
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                }
            },
        ],
        images: {
            logo: empresa.logo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico:{
                fontSize: 8
            },
            tituloTabla:{
                fontSize: 8,
                bold: true, 
                fillColor: '#cccccc', 
                style: 'subheader', 
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            }
        },
        pageSize: 'LETTER',
        pageMargins: [ 20, 20, 20, 20 ],
    }
  return dd;
};


export default reporteDeFlujoDeEfectivoPdf;
